/**
 * LOVELOOP – fixe "Add to cart"-Leiste auf der Produktseite (nur Handy).
 * - Sichtbar, solange der eigentliche Button nicht im Bild ist.
 * - Hat der Kunde noch keine Größe aktiv gewählt, scrollt ein Tipp zur
 *   Größenauswahl (damit nicht versehentlich die vorausgewählte Größe im
 *   Warenkorb landet). Danach legt der Tipp das Produkt in den Warenkorb.
 */
(function () {
  var mq = window.matchMedia('(max-width: 749px)');

  function visible(el) {
    return !!(el && el.offsetParent);
  }

  function mainButton() {
    var all = document.querySelectorAll('product-form-component [ref="addToCartButton"]');
    for (var i = 0; i < all.length; i++) if (visible(all[i])) return all[i];
    return null;
  }

  function mainPicker() {
    var all = document.querySelectorAll('variant-picker');
    for (var i = 0; i < all.length; i++) if (visible(all[i])) return all[i];
    return null;
  }

  function needsChoice(picker) {
    if (!picker) return false;
    var groups = {};
    var inputs = picker.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < inputs.length; i++) {
      groups[inputs[i].name] = (groups[inputs[i].name] || 0) + 1;
    }
    for (var k in groups) if (groups[k] > 1) return true;
    return false;
  }

  var sizeChosen = false;
  var mainInView = false;

  var bar = document.createElement('div');
  bar.className = 'll-sticky-atc';
  bar.setAttribute('aria-hidden', 'true');
  bar.innerHTML =
    '<p class="ll-sticky-atc__hint" hidden>Please select your size</p>' +
    '<button type="button" class="button ll-sticky-atc__button" tabindex="-1">Add to cart</button>';
  var barButton = bar.querySelector('button');
  var hint = bar.querySelector('.ll-sticky-atc__hint');

  function sync() {
    var btn = mainButton();
    var show = mq.matches && btn && !mainInView;
    bar.classList.toggle('ll-sticky-atc--visible', !!show);
    document.documentElement.classList.toggle('ll-has-sticky-atc', !!show);
    if (!btn) return;
    var label = (btn.innerText || '').trim();
    var choose = !sizeChosen && needsChoice(mainPicker());
    if (choose) {
      barButton.textContent = 'Select size';
      barButton.disabled = false;
    } else {
      barButton.textContent = label || 'Add to cart';
      barButton.disabled = !!btn.disabled;
    }
  }

  function flashHint() {
    hint.hidden = false;
    clearTimeout(flashHint.t);
    flashHint.t = setTimeout(function () {
      hint.hidden = true;
    }, 2500);
  }

  barButton.addEventListener('click', function () {
    var btn = mainButton();
    if (!btn) return;
    var picker = mainPicker();
    if (!sizeChosen && needsChoice(picker)) {
      picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
      picker.classList.add('ll-picker-highlight');
      setTimeout(function () {
        picker.classList.remove('ll-picker-highlight');
      }, 1600);
      flashHint();
      return;
    }
    if (btn.disabled) return;
    btn.click();
  });

  // Aktive Größenwahl erkennen
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t instanceof Element && t.closest('variant-picker')) {
      sizeChosen = true;
      hint.hidden = true;
      setTimeout(sync, 50);
      setTimeout(sync, 600); // nach dem Neuladen des Buttons (Varianten-Update)
    }
  });

  var io = null;
  var observedBtn = null;
  function observe() {
    if (io) io.disconnect();
    var btn = mainButton();
    observedBtn = btn;
    if (!btn || !('IntersectionObserver' in window)) return sync();
    io = new IntersectionObserver(function (entries) {
      mainInView = entries[0].isIntersecting;
      sync();
    });
    io.observe(btn);
  }

  function init() {
    if (!mainButton() && !document.querySelector('product-form-component')) return;
    document.body.appendChild(bar);
    observe();
    sync();

    // Button wird bei Variantenwechsel ggf. neu gerendert
    var mo = new MutationObserver(function () {
      if (mainButton() !== observedBtn) observe();
      sync();
    });
    var form = document.querySelector('product-form-component');
    if (form) mo.observe(form.closest('.shopify-section') || form, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled'] });

    if (mq.addEventListener) mq.addEventListener('change', function () { observe(); sync(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/**
 * LOVELOOP – Artikelbeschreibung auf dem Handy eingeklappt
 * (als erste Klappbox "description" über "shipping & returns").
 */
(function () {
  function collapseDescription() {
    var group = document.querySelector('.hidden--desktop.group-block > .group-block-content');
    if (!group) return;
    var desc = group.querySelector(':scope > [class*="product_description"]');
    var accordion = group.querySelector(':scope > .accordion');
    if (!desc || !accordion || accordion.querySelector('[data-ll-description]')) return;
    var template = accordion.querySelector('accordion-custom');
    if (!template) return;

    var row = template.cloneNode(true);
    var details = row.querySelector('details');
    var summary = row.querySelector('summary');
    var content = row.querySelector('.details-content');
    if (!details || !summary || !content) return;

    details.removeAttribute('open');
    details.setAttribute('data-ll-description', '');
    row.removeAttribute('open-by-default-on-desktop');
    row.removeAttribute('open-by-default-on-mobile');

    // Überschrift ersetzen, Icons behalten
    for (var i = summary.childNodes.length - 1; i >= 0; i--) {
      var n = summary.childNodes[i];
      if (n.nodeType === 3) summary.removeChild(n);
    }
    summary.insertBefore(document.createTextNode('description'), summary.firstChild);

    content.innerHTML = '';
    content.appendChild(desc);
    accordion.insertBefore(row, template);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', collapseDescription);
  else collapseDescription();
})();
